"use client"

import CTA from "@/components/Category/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

export const printerContents: ReactNode = (
  <>
    <section className="mb-6">
      <h2 className="text-2xl font-extrabold mb-3">Sewa Printer Terdekat: Pilihannya Bukan Lagi Beli</h2>
      <p className="mb-4 text-base">
        Mikir panjang buat beli printer? Tinta mahal, error dadakan, atau maintenance nguras waktu? Sekarang bukan zamannya. <strong className="font-semibold"> Sewa printer terdekat </strong> justru jadi pilihan cerdas. Dari event 3 hari
        sampai kontrak jangka panjang, semua bisa. Tanpa drama. Tanpa biaya tersembunyi.
      </p>
    </section>
    <section className="mb-8 grid gap-6">
      <article className="bg-white shadow-lg rounded-2xl p-6 border border-gray-200">
        <h3 className="text-xl font-semibold mb-2">Pilihan Printer Lengkap, Siap Kerja Keras</h3>
        <p className="text-sm">
          Laser? Inkjet? Printer multifungsi buat scan, copy, dan print sekaligus? Semua ada. Butuh cetak foto kualitas tinggi atau ribuan lembar dokumen kantor? Langsung pilih unitnya. Semua printer kami ready dan berkualitas tinggi.
          Bukan bekas nganggur, tapi printer yang layak disandingkan sama kebutuhan profesional.
        </p>
      </article>
      <article className="bg-white shadow-lg rounded-2xl p-6 border border-gray-200">
        <h3 className="text-xl font-semibold mb-2">Sewa Printer Terdekat, Kirim Hari Ini Juga</h3>
        <p className="text-sm">Lokasimu di Jakarta, Tangerang, Bandung, Surabaya, atau kota besar lainnya? Kami antar hari ini juga. Gak perlu nunggu minggu depan. Pengiriman kilat, langsung dari gudang terdekat.</p>
      </article>
      <article className="bg-white shadow-lg rounded-2xl p-6 border border-gray-200">
        <h3 className="text-xl font-semibold mb-2">Harga Sewa Printer Terdekat: Transparan & Bisa Nego</h3>
        <p className="text-sm">
          Budget tipis? Tenang. Mulai dari sewa harian, mingguan, sampai bulanan, <strong>harga sewa printer terdekat</strong> bisa kamu sesuaikan. Mau sewa Canon, Epson, HP, Brother, atau printer A3 sekalipun? Kami kasih opsi harga
          terbaik sesuai spek dan tipe printer yang kamu cari.
        </p>
      </article>
      <article className="bg-white shadow-lg rounded-2xl p-6 border border-gray-200">
        <h3 className="text-xl font-semibold mb-2">Tinta, Refill, dan Servis? Bukan Urusan Kamu</h3>
        <p className="text-sm">
          Sewa printer itu bukan cuma pinjam alat. Itu termasuk refill tinta, maintenance, dan teknisi on-call kalau ada gangguan. Cukup bilang, teknisi kami langsung turun tangan atau ganti unit tanpa ribet. Semua udah termasuk.
        </p>
      </article>
      <article className="bg-white shadow-lg rounded-2xl p-6 border border-gray-200">
        <h3 className="text-xl font-semibold mb-2">Support Langsung, Tanpa Drama</h3>
        <p className="text-sm">Selama masa sewa, kamu gak sendirian. Tim kami standby 24/7. Mau konsultasi spek printer terbaik untuk usaha cetak, atau troubleshooting hasil print buram, kami bantu sampai tuntas.</p>
      </article>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-bold mb-3">Durasi Fleksibel & Bisa Upgrade</h2>
      <p className="text-base">
        Mulai dari sewa printer 1 hari buat pameran, sampai kontrak bulanan buat kantor startup. Semua bisa dinego. Bahkan saat kebutuhan berubah, kamu bisa upgrade unit ke spek lebih tinggi tanpa ganti kontrak.
      </p>
    </section>
    <section className="mb-8">
      <h2 className="text-xl font-bold mb-3">Pengalaman Nyewa Printer yang Beneran Nyaman</h2>
      <p className="text-base">
        Kami tahu rasanya dikejar deadline tapi printer malah error. Makanya kami hadir bukan cuma kasih printer. Tapi kasih rasa tenang. <strong>Sewa printer terdekat</strong> sekarang bukan soal hemat biaya aja, tapi juga hemat waktu,
        energi, dan emosi.
      </p>
    </section>

    <CTA
      title="Siap Ngeprint Kerjamu Bosku?"
      description="🚚 Butuh sewa printer terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Printer Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20printer.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ
      category="Printer"
    />
  </>
);
